import React from 'react';

import { AuthStore } from '~/modules/auth/AuthStore';
import { LangStore } from '~/modules/lang/LangStore';
import { MessagesStore } from '~/modules/messages/MessagesStore';

class RootStore {
  langStore: LangStore;
  authStore: AuthStore;

  messagesStore: MessagesStore;

  constructor() {
    this.langStore = new LangStore();
    this.authStore = new AuthStore();

    this.messagesStore = new MessagesStore();
  }

  init = async () => {
    await Promise.all(
      Object.values(this).map((store) => {
        return store?.init ? store?.init() : Promise.resolve();
      }),
    );
  };

  reset = async () => {
    await Promise.all(
      Object.values(this).map((store) => {
        return store.reset ? store.reset() : Promise.resolve();
      }),
    );
  };
}

export const rootStore = new RootStore();

export const storesContext = React.createContext(rootStore);
